import React from "react"
import styled from "styled-components"
import { useContext, useEffect, useState } from "react"
import { ClipboardBtn } from "./clipboard-btn"
import { AuthContext } from "gatsby-source-dek-wp"
import { useMap } from "react-map-gl"

const Wrapper = styled.div`
  position: absolute;
  right: 10px;
  bottom: 30px;
  font-family: "Roboto Condensed";
  font-size: 0.7em;
  text-align: right;
  z-index: 10;
  max-width: 200px;
  word-break: break-all;

  @media screen and (max-width: ${(p) => p.theme.breakpointMobile}) {
    bottom: 90px;
    visibility: hidden;
  }
  .map-type-box & {
    bottom: 90px;
  }
`

export const CameraDebug = () => {
  const [, setCounter] = useState(0)
  const { default: map } = useMap()
  useEffect(() => {
    if (!map) return
    const update = () => setCounter((c) => c + 1)
    map.on("move", update)
    return () => {
      map.off("move", update)
    }
  }, [map])
  const isAuthed = useContext(AuthContext)
  if (!map || !isAuthed) return null
  const { lng, lat } = map.getCenter()
  const center = [round(lng), round(lat)]
  const zoom = round(map.getZoom(), 1)
  const bearing = Math.round(map.getBearing())
  const pitch = Math.round(map.getPitch())
  const cameraOpts = { center, zoom, bearing, pitch }
  return (
    <Wrapper>
      <div>
        {JSON.stringify(cameraOpts)}{" "}
        <ClipboardBtn text={JSON.stringify(cameraOpts)} />
      </div>
    </Wrapper>
  )
}

function round(x: number, decimalPlaces = 5) {
  return Math.round(x * 10 ** decimalPlaces) / 10 ** decimalPlaces
}
